import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import CreatorCampaigns from '@/components/CreatorCampaigns';
import BrandCampaigns from '@/components/BrandCampaigns';
import UGCCampaigns from '@/components/UGCCampaigns';
import TTSRetainerCampaigns from '@/components/TTSRetainerCampaigns';

export default function Campaigns() {
  return (
    <div className="space-y-6">
      <h1 className="text-xl sm:text-2xl font-bold tracking-tight">Campaigns Manager</h1>
      <Tabs defaultValue="creator" className="w-full">
        <TabsList>
          <TabsTrigger value="creator">Reward Campaigns (Creator App)</TabsTrigger>
          <TabsTrigger value="brand">Reward Campaigns (Brand Dashboard)</TabsTrigger>
          <TabsTrigger value="ugc">UGC Campaigns</TabsTrigger>
          <TabsTrigger value="tts">TTS Retainer Campaigns</TabsTrigger>
        </TabsList>
        <TabsContent value="creator">
          <CreatorCampaigns />
        </TabsContent>
        <TabsContent value="brand">
          <BrandCampaigns />
        </TabsContent>
        <TabsContent value="ugc">
          <UGCCampaigns />
        </TabsContent>
        <TabsContent value="tts">
          <TTSRetainerCampaigns />
        </TabsContent>
      </Tabs>
    </div>
  );
}
